<!-- TEMPLATE -->
<template>
  <a @click="routeHome">
    <div class="header-logo-container">
      <img
        v-if="logoImg.length > 1"
        key="headerLogo"
        align="left"
        class="header-logo"
        :src="logoImg"
        :height="height"
        :width="width"
        />
      <dean-icon
        v-else
        key="headerLogo"
        class="header-logo"
        :glyph="logo"
        :height="height"
        :width="width"
      ></dean-icon>
    </div>
  </a>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// SVG
import deanOneHeaderComponents from '../svg/logos/dean-components/dc-header.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanHeaderLogo extends Vue {
  // PROPS
  @Prop() width!: string;
  @Prop() height!: string;
  @Prop({ default: false }) defaultRoute: boolean;
  @Prop({
    default: function() {
      return deanOneHeaderComponents;
    }
  })
  logo!: object;
  @Prop({ default: ''}) logoImg!: string;

  deanOneHeaderComponents: object = deanOneHeaderComponents;

  //METHODS
  routeHome() {
    if (this.defaultRoute == true) {
      this.$router.push('/');
    }
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER LOGO
.header-logo-container {
  height: 100%;
  max-width: 320px;
  padding: 20px 10px 20px 10px;
  cursor: pointer;
  .header-logo {
    @include vertical-align(50%);
    max-width: 100%;
    height: 100%;
  }
}
</style>
